/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectPermission = {
    DailyOverview: 'DailyOverview',
    MainOverview: 'MainOverview',
    DiscountsAndCoupons: 'DiscountsAndCoupons',
    Profitability: 'Profitability',
    MarketingChannelOverview: 'MarketingChannelOverview',
    ProjectProfile: 'ProjectProfile',
    ProjectIntegrations: 'ProjectIntegrations',
    ProjectBilling: 'ProjectBilling',
    ProjectAffiliate: 'ProjectAffiliate',
    ProjectMailing: 'ProjectMailing',
    ProjectOfflineSpends: 'ProjectOfflineSpends',
    ProjectUsers: 'ProjectUsers',
    ProjectInvitations: 'ProjectInvitations'
} as const;
export type ProjectPermission = typeof ProjectPermission[keyof typeof ProjectPermission];


export function instanceOfProjectPermission(value: any): boolean {
    for (const key in ProjectPermission) {
        if (Object.prototype.hasOwnProperty.call(ProjectPermission, key)) {
            if (ProjectPermission[key as keyof typeof ProjectPermission] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectPermissionFromJSON(json: any): ProjectPermission {
    return ProjectPermissionFromJSONTyped(json, false);
}

export function ProjectPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectPermission {
    return json as ProjectPermission;
}

export function ProjectPermissionToJSON(value?: ProjectPermission | null): any {
    return value as any;
}

export function ProjectPermissionToJSONTyped(value: any, ignoreDiscriminator: boolean): ProjectPermission {
    return value as ProjectPermission;
}

